module.exports = __webpack_public_path__ + "static/media/delete.a24d83e3.svg";